export const manageLibraryTableSelector = (state) =>
  state.manageLibraryReducer.libraryTableData;
  export const manageTableRowDataSelector = (state) =>
  state.manageLibraryReducer.tableRowData;
  export const manageEditProductDataSelector = (state) =>
  state.manageLibraryReducer.editProductData;